
import linq from 'linq'
import Vue from 'vue'
import { PutProcess } from '@/api/hep2'
const state = {
    sinourpickerdata: [],
    functions: {
    }
}

const mutations = {
    GET_SINOUR_PICKER_DATA(state, {
        processname,
        params,
        onloaded,
        onloading,
        ongetdata
    }) {
        var item = linq.from(state.sinourpickerdata).firstOrDefault(function(x) {
            return x.processname === processname && x.params === params
        }, null)
        if (item) {
            if (item.isloaded) {
                if (typeof onloaded === 'function') {
                    onloaded(item.data)
                }
            } else {
                if (typeof onloading === 'function') {
                    onloading()
                }
            }
        } else {
            item = {
                processname: processname,
                params: params,
                data: [],
                isloading: false,
                isloaded: false
            }
            state.sinourpickerdata.push(item)
            if (typeof ongetdata === 'function') {
                item.isloading = true
                ongetdata(function(data) {
                    item.data = data
                    item.isloaded = true
                    item.isloaded = true
                    onloaded(item.data)
                    Vue.prototype.$bus.$emit('sinourpickerdata', {
                        processname,
                        params,
                        data
                    })
                })
            }
        }
    },
    GET_FUNCTIONS(state, {
        functions,
        callback
    }) {
        // eslint-disable-next-line no-prototype-builtins
        if (linq.from(functions).any(p => state.functions.hasOwnProperty(p) === false)) {
            PutProcess('ExecProcess', {
                Process: `GetStyleFunRst '${functions.toString()}'`
            }).then(ret => {
                const list = ret[0]
                for (let i = 0; i < functions.length; i++) {
                    state.functions[functions[i]] = linq.from(list).where(p => p.VID === functions[i]).toArray()
                }
                callback(list)
            })
        } else {
            let list = []
            for (let i = 0; i < functions.length; i++) {
                list = list.concat(state.functions[functions[i]])
            }
            callback(list)
        }
    }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
